import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { defaultLanguageCode, TENANT_SLANG_SUFFIX } from '.';
import { LANGUAGE_KEY, LocalStorage } from '../storage';
import csCZDefine from './locales/cs-CZ-x-define.json';
import csCZEdri from './locales/cs-CZ-x-edri.json';
import csCZ from './locales/cs-CZ.json';
import daDKEdri from './locales/da-DK-x-edri.json';
import daDK from './locales/da-DK.json';
import deDEEdri from './locales/de-DE-x-edri.json';
import deDE from './locales/de-DE.json';
import enGBDefine from './locales/en-GB-x-define.json';
import enGBEdri from './locales/en-GB-x-edri.json';
import enGBIgn from './locales/en-GB-x-ign.json';
import enGB from './locales/en-GB.json';
import esESIgn from './locales/es-ES-x-ign.json';
import esES from './locales/es-ES.json';
import etEE from './locales/et-EE.json';
import frFR from './locales/fr-FR.json';
import hrHR from './locales/hr-HR.json';
import huHUEdri from './locales/hu-HU-x-edri.json';
import huHU from './locales/hu-HU.json';
import itITEdri from './locales/it-IT-x-edri.json';
import itIT from './locales/it-IT.json';
import ltLTIgn from './locales/lt-LT-x-ign.json';
import ltLT from './locales/lt-LT.json';
import lvLVIgn from './locales/lv-LV-x-ign.json';
import lvLV from './locales/lv-LV.json';
import nlNLEdri from './locales/nl-NL-x-edri.json';
import nlNL from './locales/nl-NL.json';
import plPLEdri from './locales/pl-PL-x-edri.json';
import plPL from './locales/pl-PL.json';
import ptPT from './locales/pt-PT.json';
import roROEdri from './locales/ro-RO-x-edri.json';
import roRO from './locales/ro-RO.json';
import slSI from './locales/sl-SI.json';
import svSEEdri from './locales/sv-SE-x-edri.json';
import svSE from './locales/sv-SE.json';

const resources = {
  'cs_cz-x-define': { translation: csCZDefine },
  'cs_cz-x-edri': { translation: csCZEdri },
  cs_cz: { translation: csCZ },
  'da_dk-x-edri': { translation: daDKEdri },
  da_dk: { translation: daDK },
  'de_de-x-edri': { translation: deDEEdri },
  de_de: { translation: deDE },
  'en_gb-x-define': { translation: enGBDefine },
  'en_gb-x-edri': { translation: enGBEdri },
  'en_gb-x-ign': { translation: enGBIgn },
  en_gb: { translation: enGB },
  'es_es-x-ign': { translation: esESIgn },
  es_es: { translation: esES },
  et_ee: { translation: etEE },
  fr_fr: { translation: frFR },
  hr_hr: { translation: hrHR },
  'hu_hu-x-edri': { translation: huHUEdri },
  hu_hu: { translation: huHU },
  'it_it-x-edri': { translation: itITEdri },
  it_it: { translation: itIT },
  'lt_lt-x-ign': { translation: ltLTIgn },
  lt_lt: { translation: ltLT },
  'lv_lv-x-ign': { translation: lvLVIgn },
  lv_lv: { translation: lvLV },
  'nl_nl-x-edri': { translation: nlNLEdri },
  nl_nl: { translation: nlNL },
  'pl_pl-x-edri': { translation: plPLEdri },
  pl_pl: { translation: plPL },
  pt_pt: { translation: ptPT },
  'ro_ro-x-edri': { translation: roROEdri },
  ro_ro: { translation: roRO },
  sl_si: { translation: slSI },
  'sv_se-x-edri': { translation: svSEEdri },
  sv_se: { translation: svSE },
};

export const resolveFallbackLanguages = (code: string): string[] => {
  const fallbackChain: string[] = [];

  const addFallback = (languageCode: string) => {
    const lowerCode = languageCode.toLowerCase();
    if (lowerCode !== defaultLanguageCode && !fallbackChain.includes(lowerCode)) {
      fallbackChain.push(lowerCode);
    }
  };

  const normalizedCode = code.toLowerCase();
  addFallback(normalizedCode);

  const tenantBaseCode = normalizedCode.includes(TENANT_SLANG_SUFFIX)
    ? normalizedCode.split(TENANT_SLANG_SUFFIX)[0]
    : normalizedCode;
  if (tenantBaseCode !== normalizedCode) {
    addFallback(tenantBaseCode);
  }

  if (tenantBaseCode !== defaultLanguageCode) {
    const baseLanguageCode = tenantBaseCode.split('_')[0];
    addFallback(baseLanguageCode);
  }

  fallbackChain.push(defaultLanguageCode);

  return fallbackChain;
};

export default i18next.use(initReactI18next).init({
  resources,
  partialBundledLanguages: true,
  lng: (LocalStorage.getItem(LANGUAGE_KEY) as string | undefined) || defaultLanguageCode,
  fallbackLng: resolveFallbackLanguages,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
});
